import { useState, useEffect, useContext, useRef } from 'react'
import styles from './styles.module.css'
import Button from '../../../components/Button'
import Table from '../../../components/Table'
import { useDispatch, useSelector } from 'react-redux'
import { StaffRosterContext } from '../../../utils/context'
import {
  getPersonFiles,
  uploadPersonFile,
  downloadPersonFile,
  deletePersonFile
} from '../../../actions/personnel/personnel'
import Confirmation from '../../../components/Confirmation/Confirmation'
import { BiTrash, BiDownload } from 'react-icons/bi'

export default function Documents() {
  const dispatch = useDispatch()
  const fileInputRef = useRef(null)

  const { addMode, mid } = useContext(StaffRosterContext)
  const { personFiles, loading } = useSelector(state => state.personnel)

  const [selectedFile, setSelectedFile] = useState(null)
  const [confirmation, setConfirmation] = useState(false)

  useEffect(() => {
    if (mid && !addMode) {
      dispatch(getPersonFiles(mid))
    }
  }, [mid, addMode, dispatch])

  const handleFileUpload = async (e) => {
    const file = e.target.files?.[0]
    if (file && mid) {
      await dispatch(uploadPersonFile(mid, file))
      // Сброс input
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
    }
  }

  const handleDownload = (fileName) => {
    if (mid && fileName) {
      dispatch(downloadPersonFile(mid, fileName))
    }
  }

  const handleDelete = async () => {
    if (confirmation?.fileName && mid) {
      await dispatch(deletePersonFile(mid, confirmation.fileName))
      setConfirmation(false)
      setSelectedFile(null)
    }
  }

  const handleRowClick = (file) => {
    setSelectedFile(selectedFile?.name === file.name ? null : file)
  }

  const renderRow = (file) => {
    const { name, size, uploaded_at, file_name } = file
    const fileName = name || file_name
    const isSelected = selectedFile?.name === fileName || selectedFile?.file_name === fileName

    return (
      <tr
        key={fileName}
        onClick={() => handleRowClick(file)}
        className={isSelected ? styles.selectedRow : ''}
      >
        <td>{fileName}</td>
        <td>{size ? `${(size / 1024).toFixed(2)} KB` : '-'}</td>
        <td>{uploaded_at || '-'}</td>
        <td>
          <i
            className={styles.actionIcon}
            onClick={(e) => {
              e.stopPropagation()
              handleDownload(fileName)
            }}
            title="Скачать"
          >
            <BiDownload />
          </i>
        </td>
        <td>
          <i
            className={styles.trash}
            onClick={(e) => {
              e.stopPropagation()
              setConfirmation({ fileName })
            }}
            title="Удалить"
          >
            <BiTrash />
          </i>
        </td>
      </tr>
    )
  }

  return (
    <div className={styles.tabWrapper}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить файл "${confirmation.fileName}"?`}
          acceptConfirmation={handleDelete}
          rejectConfirmation={() => setConfirmation(false)}
        />
      )}

      {/* Таблица файлов */}
      <div className={styles.qualificationTableSection}>
        <Table>
          <thead>
            <tr>
              <th>Название файла</th>
              <th>Размер</th>
              <th>Дата загрузки</th>
              <th style={{ width: '50px' }}>Скачать</th>
              <th style={{ width: '50px' }}>Удалить</th>
            </tr>
          </thead>
          <tbody>
            {personFiles?.length > 0 ? (
              personFiles.map(renderRow)
            ) : (
              <tr>
                <td colSpan="5" className={styles.emptyTable}>
                  Нет загруженных файлов
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Кнопки управления */}
      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <div className={styles.qualificationButtonsInline}>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileUpload}
              style={{ display: 'none' }}
            />
            <Button onClick={() => fileInputRef.current?.click()} disabled={loading}>
              + Загрузить файл
            </Button>
            {selectedFile && (
              <Button
                mode="white"
                onClick={() => handleDownload(selectedFile.name || selectedFile.file_name)}
              >
                Скачать выбранный
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
